import script from "./newsAllV2.vue?vue&type=script&setup=true&lang=js"
export * from "./newsAllV2.vue?vue&type=script&setup=true&lang=js"

import "./newsAllV2.vue?vue&type=style&index=0&id=62faf45a&lang=scss&scoped=true"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62faf45a"]])

export default __exports__